export enum HoldFunction {
  MIN = 'MIN',
  MAX = 'MAX',
  NONE = 'NONE'
}